/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Paywall_Benefit_Real_TreeInputs */

const en_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn focus into real trees and make a real impact`)
};

const ar_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حوّل تركيزك إلى أشجار حقيقية واصنع تأثيرًا حقيقيًا`)
};

const de_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandeln Sie den Fokus in echte Bäume und erzielen Sie eine echte Wirkung`)
};

const es_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte tu concentración en árboles reales y genera un impacto real`)
};

const fr_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transformez votre concentration en véritables arbres et ayez un réel impact`)
};

const it_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti la concentrazione in alberi veri e crea un impatto tangibile`)
};

const ja_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中することで本物の木を植え、現実世界に貢献`)
};

const ko_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중력으로 실제 나무를 심고 선한 영향력을 발휘할 수 있어요`)
};

const pt_br_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme seu foco em árvores de verdade e cause um impacto real`)
};

const ru_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Превращайте фокусировку в настоящие деревья, чтобы сделать настоящий вклад`)
};

const th_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนการโฟกัสของคุณเป็นต้นไม้จริง และสร้างผลกระทบที่แท้จริง`)
};

const tr_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanı gerçek ağaçlara dönüştür ve gerçek bir etki yarat`)
};

const zh_cn_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用你的专注，在地球种下真树`)
};

const zh_tw_onboarding_paywall_benefit_real_tree = /** @type {(inputs: Onboarding_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用你的專注，在地球種下真樹`)
};

/**
* | output |
* | --- |
* | "Turn focus into real trees and make a real impact" |
*
* @param {Onboarding_Paywall_Benefit_Real_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onboarding_paywall_benefit_real_tree = /** @type {((inputs?: Onboarding_Paywall_Benefit_Real_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Paywall_Benefit_Real_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "ar") return ar_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "de") return de_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "es") return es_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "fr") return fr_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "it") return it_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "ja") return ja_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "ko") return ko_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "pt_br") return pt_br_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "ru") return ru_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "th") return th_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "tr") return tr_onboarding_paywall_benefit_real_tree(inputs)
	if (locale === "zh_cn") return zh_cn_onboarding_paywall_benefit_real_tree(inputs)
	return zh_tw_onboarding_paywall_benefit_real_tree(inputs)
});